/* NOA Matcha - product page buy box.
   Variant selection, grade meter, per-unit cost and running total.
   The price format comes from the shop's money_format setting; the digit
   grouping follows the page locale (en-AU here, not the tr-TR grouping the
   Alpha build shipped with). */
(function () {
  "use strict";

  function boot(root) {
    if (!root || root.dataset.alphaReady === "1") return;
    root.dataset.alphaReady = "1";

    var dataEl = root.querySelector("[data-alpha-variants]");
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = cfg.variants || [];
    var fmt = cfg.moneyFormat || "{{amount}}";
    var idInput = root.querySelector("[data-alpha-id]");
    var qtyInput = root.querySelector("[data-alpha-qty]");
    var elNow = root.querySelector("[data-alpha-price]");
    var elWas = root.querySelector("[data-alpha-compare]");
    var elSave = root.querySelector("[data-alpha-save]");
    var elPer = root.querySelector("[data-alpha-per]");
    var elTotal = root.querySelector("[data-alpha-total]");
    var elBtn = root.querySelector("[data-alpha-submit]");
    var elExpress = root.querySelector("[data-alpha-express]");

    var locale = document.documentElement.lang || "en-AU";
    function group(n, decimals) {
      try {
        return new Intl.NumberFormat(locale, {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }).format(n);
      } catch (e) {
        return (Math.round(n * 100) / 100).toFixed(decimals);
      }
    }
    function money(cents) {
      var amount = cents / 100;
      if (/amount_no_decimals/.test(fmt)) {
        return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(amount, 0));
      }
      return fmt.replace(/\{\{\s*amount\s*\}\}/g, group(amount, 2));
    }
    /* "$30.00 OFF" reads heavy on a badge, so a whole amount drops its
       decimals and becomes "$30 OFF". Amounts with cents keep them. The
       separator is taken from the formatted string, not assumed to be a dot. */
    function moneyShort(cents) {
      var s = money(cents);
      return cents % 100 === 0 ? s.replace(/([.,])0{2}(?!\d)/, "") : s;
    }

    function current() {
      var id = idInput && idInput.value;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return variants[0];
    }

    function qty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }

    function render() {
      var v = current();
      if (!v) return;
      var q = qty();
      if (qtyInput) qtyInput.value = q;

      if (elNow) elNow.textContent = money(v.price);

      /* The compare-at price is only shown when it is GREATER than the selling
         price. While a product carries no compare-at, neither this block nor
         the discount badge is ever rendered. */
      var validCompare = v.compare != null && v.compare > v.price;
      if (elWas) {
        elWas.textContent = validCompare ? money(v.compare) : "";
        elWas.hidden = !validCompare;
      }
      if (elSave) {
        if (validCompare) {
          elSave.textContent = moneyShort(v.compare - v.price) + " OFF";
          elSave.hidden = false;
        } else {
          elSave.hidden = true;
        }
      }

      /* Per-unit cost: the line is hidden entirely when no serve count is set. */
      if (elPer) {
        if (v.units && v.units > 0) {
          elPer.innerHTML = v.units + " " + (cfg.unitNoun || "serve") +
            " · " + (cfg.unitLabel || "per serve") + " <b>" +
            money(Math.round(v.price / v.units)) + "</b>";
          elPer.hidden = false;
        } else {
          elPer.hidden = true;
        }
      }

      if (elTotal) elTotal.textContent = money(v.price * q);

      if (elBtn && elBtn.getAttribute("aria-busy") !== "true") {
        elBtn.disabled = !v.available;
        var lbl = elBtn.querySelector("[data-alpha-label]");
        if (lbl) lbl.textContent = v.available ? (cfg.addLabel || "Add to cart") : (cfg.soldLabel || "Sold out");
      }

      /* Express checkout sends the buyer straight to a wallet, so it has to
         disappear for a variant that cannot be bought. Shopify renders the
         buttons once on page load and does not re-render them on a variant
         change, so hiding the wrapper is what keeps the two in step. */
      if (elExpress) elExpress.hidden = !v.available;

      root.querySelectorAll("[data-alpha-variant]").forEach(function (el) {
        el.classList.toggle("on", String(el.dataset.alphaVariant) === String(v.id));
      });

      syncOptions(v);
    }

    root.querySelectorAll("[data-alpha-variant] input[type=radio]").forEach(function (r) {
      r.addEventListener("change", function () {
        if (idInput) idInput.value = r.value;
        render();
        showVariantMedia(current());
      });
    });

    /* ---------------------------------------------------------------
       Gallery. The photos sit in a horizontal scroller that snaps one at
       a time (CSS), so swiping works on its own. Here: the thumbnails and
       arrows scroll it to a photo, the counter and the highlighted
       thumbnail follow whatever is on screen, a mouse can drag it, the
       arrow keys move it, and picking a variant that has its own photo
       brings that photo up.
       --------------------------------------------------------------- */
    var track = root.querySelector("[data-alpha-track]");
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll(".a-gal-slide")) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-alpha-thumb]"));
    var thumbStrip = root.querySelector("[data-alpha-thumbs]");
    var btnPrev = root.querySelector("[data-alpha-prev]");
    var btnNext = root.querySelector("[data-alpha-next]");
    var elIdx = root.querySelector("[data-alpha-idx]");
    var galIndex = 0;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function slideWidth() {
      return track ? track.clientWidth || 1 : 1;
    }
    function indexFromScroll() {
      if (!track) return 0;
      var i = Math.round(track.scrollLeft / slideWidth());
      return Math.max(0, Math.min(slides.length - 1, i));
    }
    function markActive(i) {
      galIndex = i;
      /* The photo on screen and the ones either side are fetched now, so a
         swipe never lands on an empty square while a lazy image loads —
         browsers are slow to start lazy images inside a sideways scroller. */
      for (var k = i - 1; k <= i + 1; k++) {
        var img = slides[k] && slides[k].querySelector("img[loading='lazy']");
        if (img) img.loading = "eager";
      }
      if (elIdx) elIdx.textContent = String(i + 1);
      if (btnPrev) btnPrev.disabled = i <= 0;
      if (btnNext) btnNext.disabled = i >= slides.length - 1;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle("on", on);
        if (on) t.setAttribute("aria-current", "true");
        else t.removeAttribute("aria-current");
      });
      /* Keep the active thumbnail in view by scrolling the strip only —
         scrollIntoView would also move the page up or down. */
      var t = thumbs[i];
      if (thumbStrip && t) {
        var left = t.offsetLeft - thumbStrip.offsetLeft;
        var right = left + t.offsetWidth;
        if (left < thumbStrip.scrollLeft) {
          thumbStrip.scrollTo({ left: left, behavior: reduceMotion ? "auto" : "smooth" });
        } else if (right > thumbStrip.scrollLeft + thumbStrip.clientWidth) {
          thumbStrip.scrollTo({ left: right - thumbStrip.clientWidth, behavior: reduceMotion ? "auto" : "smooth" });
        }
      }
    }
    /* While a thumbnail, arrow or variant scrolls the track smoothly, the
       photos it passes on the way are not announced as the current one. */
    var goingTo = -1, goingUntil = 0, settle;
    function goTo(i, instant) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      goingTo = i;
      goingUntil = Date.now() + 700;
      track.scrollTo({ left: i * slideWidth(), behavior: instant || reduceMotion ? "auto" : "smooth" });
      markActive(i);
      /* Safety net: some browsers (older Safari with snap points, or a page
         in a background tab) never finish a smooth scroll. If the photo has
         not arrived shortly after, jump straight to it. */
      clearTimeout(settle);
      settle = setTimeout(function () {
        if (galIndex === i && !drag && Math.abs(track.scrollLeft - i * slideWidth()) > 2) {
          track.scrollLeft = i * slideWidth();
        }
      }, 900);
    }
    function showVariantMedia(v) {
      if (!v || v.media == null || !slides.length) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(v.media)) {
          if (i !== galIndex) goTo(i);
          return;
        }
      }
    }

    if (track && slides.length > 1) {
      if (btnPrev) { btnPrev.hidden = false; btnPrev.addEventListener("click", function () { goTo(galIndex - 1); }); }
      if (btnNext) { btnNext.hidden = false; btnNext.addEventListener("click", function () { goTo(galIndex + 1); }); }
      thumbs.forEach(function (t) {
        t.addEventListener("click", function () { goTo(parseInt(t.dataset.alphaThumb, 10) || 0); });
      });

      var ticking = false;
      track.addEventListener("scroll", function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var i = indexFromScroll();
          if (goingTo !== -1) {
            if (i === goingTo || Date.now() > goingUntil) goingTo = -1;
            else return;
          }
          if (i !== galIndex) markActive(i);
        });
      }, { passive: true });

      track.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") { e.preventDefault(); goTo(galIndex + 1); }
        else if (e.key === "ArrowLeft") { e.preventDefault(); goTo(galIndex - 1); }
      });

      /* Mouse dragging. Touch and trackpads scroll natively; a mouse has
         no sideways gesture, so a drag is turned into a scroll and then
         settles on the nearest photo (or the next one, for a quick flick). */
      var drag = null;
      var justDragged = false;
      track.addEventListener("pointerdown", function (e) {
        if (e.pointerType !== "mouse" || e.button !== 0) return;
        goingTo = -1;
        drag = { x: e.clientX, left: track.scrollLeft, start: galIndex, moved: false, t: Date.now() };
      });
      window.addEventListener("pointermove", function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) < 5) return;
        if (!drag.moved) { drag.moved = true; track.classList.add("is-drag"); }
        track.scrollLeft = drag.left - dx;
      });
      window.addEventListener("pointerup", function (e) {
        if (!drag) return;
        var d = drag;
        drag = null;
        if (!d.moved) return;
        track.classList.remove("is-drag");
        var dx = e.clientX - d.x;
        var target = indexFromScroll();
        var quick = Date.now() - d.t < 300 && Math.abs(dx) > 30;
        if (target === d.start && (quick || Math.abs(dx) > slideWidth() * 0.18)) {
          target = d.start + (dx < 0 ? 1 : -1);
        }
        goTo(target);
        justDragged = true;
        setTimeout(function () { justDragged = false; }, 0);
      });
      track.addEventListener("click", function (e) {
        if (justDragged) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      /* A resize or a phone turning sideways changes the slide width, so
         the track is put back on the photo it was showing. */
      var rz, lastW = slideWidth();
      window.addEventListener("resize", function () {
        clearTimeout(rz);
        rz = setTimeout(function () {
          /* Phones fire resize when the address bar slides away; only a
             change of width needs the track re-aligned. */
          if (slideWidth() === lastW) return;
          lastW = slideWidth();
          goTo(galIndex, true);
        }, 120);
      });

      markActive(indexFromScroll());
    }

    /* ---------------------------------------------------------------
       One dropdown per option (Package, Session …) for products that have
       more than one. The chosen values are matched to a variant, whose id
       goes into the form. Each entry in a dropdown says whether it can be
       booked together with what is chosen in the others, so a sold-out
       combination is labelled before it is picked rather than after.
       --------------------------------------------------------------- */
    var selects = Array.prototype.slice.call(root.querySelectorAll("select[data-alpha-option]"));

    function chosen() {
      return selects.map(function (s) { return s.value; });
    }
    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        if (!o) continue;
        var ok = true;
        for (var k = 0; k < vals.length; k++) {
          if (o[k] !== vals[k]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }
    function syncOptions(v) {
      if (!selects.length) return;
      selects.forEach(function (s, i) {
        if (v.options && v.options[i] != null && s.value !== v.options[i]) s.value = v.options[i];
      });
      var vals = chosen();
      selects.forEach(function (s, i) {
        Array.prototype.forEach.call(s.options, function (o) {
          if (o.dataset.base == null) o.dataset.base = o.textContent.trim();
          var probe = vals.slice();
          probe[i] = o.value;
          var m = findVariant(probe);
          var note = !m ? " — Unavailable" : (!m.available ? " — " + (cfg.soldLabel || "Sold out") : "");
          var text = o.dataset.base + note;
          if (o.textContent !== text) o.textContent = text;
        });
      });
    }

    selects.forEach(function (s, i) {
      s.addEventListener("change", function () {
        var vals = chosen();
        var m = findVariant(vals);
        if (!m) {
          /* That combination does not exist at all: keep the value just
             picked and move the other dropdowns to the closest variant
             that has it, preferring one that can still be booked. */
          var best = null, bestScore = -1;
          variants.forEach(function (v) {
            if (!v.options || v.options[i] !== vals[i]) return;
            var score = v.available ? 100 : 0;
            v.options.forEach(function (x, k) { if (x === vals[k]) score++; });
            if (score > bestScore) { best = v; bestScore = score; }
          });
          m = best;
        }
        if (!m) return;
        if (idInput) idInput.value = m.id;
        render();
        showVariantMedia(m);
        /* Keep the address in step, as Dawn does, so a shared or reloaded
           link opens on the same package and session. */
        try {
          var u = new URL(window.location.href);
          u.searchParams.set("variant", m.id);
          window.history.replaceState(window.history.state, "", u.toString());
        } catch (e) {}
      });
    });

    /* ---------------------------------------------------------------
       Add to cart without leaving the page.
       The form still posts to /cart/add, so with JavaScript off, or with
       the theme's cart set to "page", it behaves exactly as before and
       lands on /cart. When the cart drawer is on the page, the submit is
       sent in the background instead, the drawer and the header bubble are
       re-rendered from the same response (Shopify's section rendering), and
       the drawer slides open — the same call Dawn's own product form makes.
       If the request fails for any reason other than a cart rule, the
       native post runs, so a customer is never left without a way to buy.
       --------------------------------------------------------------- */
    var form = root.querySelector("form[action*='/cart/add']");
    var elErr = null;

    function showError(msg) {
      if (!elErr) {
        elErr = document.createElement("p");
        elErr.className = "a-atc-error";
        elErr.setAttribute("role", "alert");
        var row = root.querySelector(".a-qtyrow");
        if (row && row.parentNode) row.parentNode.insertBefore(elErr, row.nextSibling);
        else if (form) form.appendChild(elErr);
      }
      elErr.textContent = msg;
      elErr.hidden = !msg;
    }

    function busy(on) {
      if (!elBtn) return;
      if (on) {
        elBtn.setAttribute("aria-busy", "true");
        elBtn.disabled = true;
      } else {
        elBtn.removeAttribute("aria-busy");
        render(); /* restores disabled/label from the selected variant */
      }
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        var drawer = document.querySelector("cart-drawer");
        if (!drawer || typeof drawer.renderContents !== "function" || !window.fetch || !window.FormData) return;
        e.preventDefault();
        if (elBtn && elBtn.getAttribute("aria-busy") === "true") return;

        showError("");
        busy(true);

        var added = false;
        var body = new FormData(form);
        var vid = String(body.get("id"));

        /* How many of this variant the drawer already holds, read before the
           request. Shopify answers "Only 1 item was added due to
           availability" with an error status even though it DID add some,
           so this is how a partial add is told apart from a refusal. */
        function qtyInDrawer() {
          var n = 0;
          drawer.querySelectorAll(".quantity__input[data-quantity-variant-id='" + vid + "']").forEach(function (i) {
            n += parseInt(i.value, 10) || 0;
          });
          return n;
        }
        var before = qtyInDrawer();

        function openWithFreshCart() {
          /* No Accept header here: on a product URL, "application/json"
             makes Shopify answer with the product JSON instead of the
             rendered sections. */
          return fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              if (drawer.classList.contains("is-empty")) drawer.classList.remove("is-empty");
              drawer.renderContents({ id: vid, sections: sections });
            });
        }
        body.append("sections", "cart-drawer,cart-icon-bubble");
        body.append("sections_url", window.location.pathname);

        fetch("/cart/add.js", {
          method: "POST",
          body: body,
          headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" }
        })
          .then(function (r) {
            /* Once Shopify has accepted the add, nothing below may post the
               form again, or the seat would be booked twice. */
            if (r.ok) added = true;
            return r.json().then(function (j) { return { ok: r.ok, json: j }; });
          })
          .then(function (res) {
            var j = res.json || {};
            if (!res.ok || j.status) {
              /* A cart rule stepped in — sold out, not enough seats left, a
                 quantity limit. Shopify's own message says which. If it
                 still added some seats, the drawer opens on the real cart
                 so the header count and the panel are never out of step. */
              busy(false);
              showError(j.description || j.message || "Sorry, that could not be added. Please try again.");
              return fetch("/cart.js", { headers: { "Accept": "application/json" } })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  var now = 0;
                  (cart.items || []).forEach(function (it) {
                    if (String(it.variant_id) === vid) now += it.quantity;
                  });
                  if (now > before) return openWithFreshCart();
                })
                .catch(function () {});
            }
            if (drawer.classList.contains("is-empty")) drawer.classList.remove("is-empty");
            drawer.renderContents(j);
            busy(false);
            /* Dawn's constants.js declares PUB_SUB_EVENTS with `const`, so it
               is a global binding but not a property of window. */
            if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "noa-buybox",
                productVariantId: body.get("id"),
                cartData: j
              });
            }
          })
          .catch(function () {
            busy(false);
            if (added) {
              /* The item is in the cart but the drawer could not be drawn:
                 show the cart page rather than adding it a second time. */
              window.location.href = (window.routes && window.routes.cart_url) || "/cart";
            } else {
              /* The request never landed: fall back to the plain post. */
              form.submit();
            }
          });
      });
    }

    var minus = root.querySelector("[data-alpha-minus]");
    var plus = root.querySelector("[data-alpha-plus]");
    if (minus) minus.addEventListener("click", function () { qtyInput.value = Math.max(1, qty() - 1); render(); });
    if (plus) plus.addEventListener("click", function () { qtyInput.value = Math.min(99, qty() + 1); render(); });
    if (qtyInput) qtyInput.addEventListener("change", render);

    render();
  }

  function init() {
    document.querySelectorAll("[data-alpha-pdp]").forEach(boot);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector("[data-alpha-pdp]");
    if (r) { r.dataset.alphaReady = ""; boot(r); }
  });
})();
